import { InvoiceModel } from "../types/invoice";
import { Invoice, InvoiceDownloadResult, PaginatedReponse, SubscriptionApiResponse } from "../types/subscription";
import Base from "./base";

class InvoiceAPI extends Base {
	constructor(token: string) {
		super(token, "/api");
	}

	async getInvoices(payload: {
		search?: string;
		paymentMethod?: string;
		page?: number;
		size?: number;
	}): Promise<SubscriptionApiResponse<PaginatedReponse<Invoice>>> {
		payload.page = (payload.page ?? 0) + 1;
		return await this.fetchJsonWithQueryParams(`/invoice/?`, "GET", payload);
	}

	async getInvoiceById(id: string): Promise<SubscriptionApiResponse<InvoiceModel>> {
		return await this.fetchJsonWithQueryParams(`/invoice/${id}`, "GET");
	}

	async downloadInvoiceById(id: string): Promise<SubscriptionApiResponse<InvoiceDownloadResult>> {
		return await this.fetchJsonWithQueryParams("/invoice/" + id + `/download`, "GET");
	}
}

export default InvoiceAPI;
